import { useRoutes } from 'react-router-dom';
import { useAuth } from 'src/hooks';
import { routes } from 'src/routes';
import { LoadingScreen } from 'src/components/others/LoadingScreen';

export const PageInitializer = () => {
  const { isInitialized } = useAuth();
  const page = useRoutes(routes);

  return isInitialized ? page : <LoadingScreen />;
};
